export default {
  "root": "_root_1hl8g_1",
  "dismiss": "_dismiss_1hl8g_1",
  "--actionable": "_--actionable_1hl8g_1",
  "--variant-faded": "_--variant-faded_1hl8g_1",
  "--variant-outline": "_--variant-outline_1hl8g_1",
  "--color-positive": "_--color-positive_1hl8g_1",
  "--color-critical": "_--color-critical_1hl8g_1",
  "--color-warning": "_--color-warning_1hl8g_1",
  "--color-primary": "_--color-primary_1hl8g_1",
  "--size-small": "_--size-small_1hl8g_1",
  "--size-medium": "_--size-medium_1hl8g_1",
  "--size-large": "_--size-large_1hl8g_1",
  "--rounded": "_--rounded_1hl8g_1",
  "--hidden": "_--hidden_1hl8g_1",
  "container": "_container_1hl8g_1",
  "--container-overlap": "_--container-overlap_1hl8g_1",
  "--container-position-top-end": "_--container-position-top-end_1hl8g_1",
  "--container-position-bottom-end": "_--container-position-bottom-end_1hl8g_1"
};import "ni:sha-256;ZLcYhyQeGjZXRfUwgL-DRAruKK8lAsfJhDGSVtWe6Mk";